var LanguageEnum = /* @__PURE__ */ ((LanguageEnum2) => {
  LanguageEnum2["Ru"] = "ru";
  LanguageEnum2["En"] = "en";
  LanguageEnum2["Uz"] = "uz";
  return LanguageEnum2;
})(LanguageEnum || {});
var CurrencyEnum = /* @__PURE__ */ ((CurrencyEnum2) => {
  CurrencyEnum2["USD"] = "USD";
  CurrencyEnum2["RUB"] = "RUB";
  CurrencyEnum2["UZS"] = "UZS";
  return CurrencyEnum2;
})(CurrencyEnum || {});
export {
  CurrencyEnum,
  LanguageEnum
};
